import "./Timeline.css"

const Item = ({side, title, date, text}) => (
  <div className={`timeline-item ${side}`}>
    <div className="card">
      <h3>{title}</h3>
      <div className="date">{date}</div>
      <p>{text}</p>
    </div>
  </div>
);

export default function Timeline() {
  return (
    <section className="timeline container" id="timeline"> 
      <h2 className="section-title">Event Timeline</h2>
      <p className="lead">Mark your calendars! Here's everything you need to know...</p>

      <div className="timeline-grid">
        <div className="line"></div>
        <Item side="left" title="Registration Opens on" date="30 - 11 - 2025" text="Early bird registration Begins!" />
        <div className="timeline-dot"></div>
        <Item side="right" title="Registration Closes on" date="03 - 01 - 2026" text="Last Chance to Reegister!" />
        <div className="timeline-dot"></div>
        <Item side="left" title="Virtuals " date="29 - 01 - 2026" text="Virtual Round Coming Up!" />
        <div className="timeline-dot"></div>
        <Item side="right" title="Release of Check-List" date="06 - 02 - 2026" text="Official Checklist Out Soon!" />
        <div className="timeline-dot"></div>
        <Item side="left" title="Accommodation Confirmation" date="13 - 02 - 2026" text="Accommodation Details Released!" />
         <div className="timeline-dot"></div>
        <Item side="right" title="Dynamic Round Starts" date="04 - 03 – 2026" text="Dynamic Rounds Begins!" />
         <div className="timeline-dot"></div>
        <Item side="left" title="Dynamic Round Ends" date="07 - 03 – 2026" text="Dynamic Rounds Concludes!" />
      </div>
    </section>
  );
}
